
import { Field } from '../../form/field';
import { OptionType } from '../../form/option-type.model';

export class ProductFormResponse {
    productForm: Field[];
    financeType: OptionType;
    isAfterSale: OptionType;
    vehicleCondition: OptionType;
    vehicleType: OptionType[];
    province: OptionType[];
    YamahaSurcharges: OptionType[];
    engine: OptionType[];

    constructor() {
        this.productForm = [];
        this.financeType = new OptionType();
        this.isAfterSale = new OptionType();
        this.vehicleCondition = new OptionType();
        this.vehicleType = [];
        this.province = [];
    }
}
